import Accordions from "./accordions";
import { Heights } from "./MatchHeight";
import Popup from "./Popup";
import SearchBar from "./Search";
import Slider from "./Slider";
import Tabs from "./Tabs";
import Menu from "./Menu";
import Team from "./team";
import Video from "./video";
window.addEventListener("DOMContentLoaded", () => {
    Heights();
    SearchBar();
    Popup();
    Slider();
    Menu();
    Team();
    Video();
    const tabsWrapper = document.querySelectorAll("[data-tab]");
    if (tabsWrapper) {
        tabsWrapper.forEach((tab) => {
            new Tabs(tab);
        });
    }
    const accordionSections = document.querySelectorAll("[data-accordions]");
    if (accordionSections.length) {
        accordionSections.forEach((accordions) => {
            new Accordions(accordions, "[data-accordion]", false);
        });
    }
    const videos = document.querySelectorAll(".js-video");
    if (videos.length) {
        videos.forEach((video) => {
            video.addEventListener("click", () => {
                console.log("clicked");
                video.classList.add("is-active");
                // Find iframe within the video container
                const iframe = video.querySelector("iframe");
                if (iframe) {
                    // Get the src attribute
                    const src = iframe.getAttribute("src");
                    if (src) {
                        // Add autoplay parameter if not already present
                        const updatedSrc = src.includes("?")
                            ? `${src}&autoplay=1`
                            : `${src}?autoplay=1`;
                        iframe.setAttribute("src", updatedSrc);
                    }
                }
            });
        });
    }
});
